(function (ko, $) {
    var ViewModel = function (updateHeight,params) {
        var self = this;
            // ✅ Access params passed in HTML via `params`
        self.showFsaBanner = ko.observable(params.showFsaBanner.toLowerCase() == "true");
        self.showDirectDepositWidget = ko.observable(params.showDirectDepositWidget.toLowerCase() == "true");
        }
    
    ko.components.register("custom-banner-widget", {
        template: { element: "template-custom-banner-widget" },
        viewModel: {
            createViewModel: function (params, componentInfo) {
                var updateHeight = updateContainerHeight(componentInfo.element);
                return new ViewModel(updateHeight,params);
            }
        }
    });
})(window.ko, window.jQuery);
